import gql from 'graphql-tag';

export const GEOCODE = gql`
  mutation Geocode(
    $query: String!
  ) {
    geocode(input: {
      query:  $query
    }) {
      results {
        mapboxId
        coordinates
        name
        number
        street
        neighborhood
        city
        state
        stateCode
        country
        countryCode
        postalCode
        localPart
        regionalPart
        nationalPart
        globalPart
      }
    }
  }
`